/** Stable error code returned by OMS when final charge is below the minimum. */
export const MIN_CHECKOUT_CHARGE_ERROR_CODE = "MIN_CHECKOUT_CHARGE";

const GENERIC_MIN_CHECKOUT_CHARGE_MESSAGE =
  "מינימום החיוב באתר הוא סכום מינימלי. יש להוסיף מוצרים נוספים כדי להשלים את הרכישה.";

function round2(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return n;
  return Math.round(n * 100) / 100;
}

export function getMinCheckoutChargeMessage(minCheckoutChargeAmount) {
  const amount = Number(minCheckoutChargeAmount);
  if (!Number.isFinite(amount) || amount <= 0) {
    return GENERIC_MIN_CHECKOUT_CHARGE_MESSAGE;
  }
  // Keep the copy fully in FE; the amount comes from the server.
  return `מינימום החיוב באתר הוא ${amount} שקלים. יש להוסיף מוצרים נוספים כדי להשלים את הרכישה.`;
}

export function isBelowMinCheckoutCharge(
  finalChargeAmount,
  minCheckoutChargeAmount,
) {
  const min = Number(minCheckoutChargeAmount);
  if (!Number.isFinite(min)) return false; // server will enforce
  return round2(finalChargeAmount) < min;
}

/** Maps OMS checkout error codes to Hebrew customer-facing messages. */
export function resolveCheckoutCustomerMessage(
  rawMessage,
  minCheckoutChargeAmount,
) {
  if (!rawMessage) return null;
  const normalized = String(rawMessage).trim();
  if (normalized === MIN_CHECKOUT_CHARGE_ERROR_CODE) {
    return getMinCheckoutChargeMessage(minCheckoutChargeAmount);
  }
  return null;
}
